import { MotifButton, MotifCardFooter, MotifFormField, MotifInput, MotifOption, MotifSelect, MotifTextArea } from "@ey-xd/motif-react";
import ListOptionSelect from "../atoms/ListOptionSelect";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";


const RoleForm = (props: any) => {
    const { onFormSubmit, onCancel, data } = props;
    const [selectedPrivileges, setSelectedPrivileges] = useState<any>([]);
    const dispatch = useDispatch()
    const { privileges } = useSelector((state: any) => state.admin);
    const filteredPrivilege = privileges && privileges.filter((ele)=> ele.Privilege_status == "Active");

    const { control, setValue, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            roleName: '',
            status: 'Active',
            description: ''
        }
    });

    
    const getRoleDetails = async () => {
        try {
        const response = await axios.get(`/roles_data/${data?.RoleId}`)
        const {Privileges} = response?.data;
        setSelectedPrivileges((Privileges ?? [])?.map((privilege) => {
            return privilege?.Privilege_id
        }))
        } catch(err) {
        console.log("error", err);
        }
    };

    useEffect(() =>{
        if(data === null || data === undefined) {
            return
        }
        getRoleDetails()
    }, [data])

    useEffect(() => {
        if (privileges) return;
        dispatch(
            {
                type: 'GET_PRIVILEGES'
            },
            {}
        );
    }, []);

    useEffect(() => {
        if (data) {
            setValue("roleName", data?.RoleName)
            setValue("status", data?.Role_status ?? "")
            setValue("description", data?.Role_Description ?? "")
        }
    }, [data])

    const onSubmit = (data) => {
        onFormSubmit({...data, privilegeArray: selectedPrivileges});
    };

    const handlePrivilegeOptionChange = (privilegeId) => {
        setSelectedPrivileges((currentSelectedPrivileges: any) => {
            if (currentSelectedPrivileges.includes(privilegeId)) {
                return currentSelectedPrivileges.filter(id => id !== privilegeId);
            } else {
                return [...currentSelectedPrivileges, privilegeId];
            }
        });
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex gap-3 mb-3 !w-full">
                <div className="sm:w-[100%] md:w-[40%] lg:w-[40%]">
                    <div>
                        <MotifFormField label="Privilege Name">
                            <Controller
                                name="roleName"
                                control={control}
                                rules={{ required: 'Role name is required' }}
                                render={({ field }) => (
                                    <MotifInput hideClearButton {...field} placeholder="Enter role name" />
                                )}
                            />
                            {errors.roleName && <p>{errors.roleName.message}</p>}
                        </MotifFormField>

                        <MotifFormField label="Status">
                            <Controller
                                name="status"
                                control={control}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select status" visibleOptions={3}>
                                        <MotifOption value="Active">Active</MotifOption>
                                        <MotifOption value="Inactive">Inactive</MotifOption>
                                    </MotifSelect>
                                )}
                            />
                        </MotifFormField>
                    </div>
                </div>
                <div className="w-full">
                    <div>
                        <MotifFormField label="Description">
                            <Controller
                                name="description"
                                control={control}
                                render={({ field }) => (
                                    <MotifTextArea {...field} placeholder="Enter description" />
                                )}
                            />
                        </MotifFormField>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-4">
                <h6>Check on the privileges to be provided to the roles:</h6>
                <div className="flex flex-col gap-1">
                    {filteredPrivilege && filteredPrivilege.map((item, index) => {
                        return (
                            <ListOptionSelect key={index}
                                checked={selectedPrivileges.includes(item?.Privilege_id)}
                                onChange={() => handlePrivilegeOptionChange(item.Privilege_id)}
                                title={item.Privilege_name} description={item.Privilege_Description} />
                        )
                    })}
                </div>
            </div>
            <hr style={{ opacity: "0.1" }} />
                <MotifCardFooter className="justify-end">
                    <MotifButton
                        onClick={onCancel}
                        type="button"
                        variant="secondary"
                        size="small"
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Cancel
                    </MotifButton>
                    <MotifButton
                        type="submit"
                        variant="primary"
                        size="small"
                        onClick={handleSubmit(onSubmit) as any}
                        disabled={ selectedPrivileges.length ? false : true }
                        className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                    >
                        Save
                    </MotifButton>
                </MotifCardFooter>
        </div>
    )
}

export default RoleForm;